import React, { useCallback, useEffect, useState } from "react";
import Layout from "../../../components/Layout";
import { ConfirmDelete } from "../../../components/Alert";
import swal from "sweetalert";
import { List } from "../../../components/_widgets/WidgetsList";
import { useAuth } from "../../../context/ContextApi";
import { convertToSlug } from "../../../config/utils";
import api from "../../../config/api";
import debounce from "lodash.debounce";
import styled from "styled-components";
import CategoryList from "./components/List/CategoryList";

import SearchInput from "../../../components/inputs/SearchInput";
import AddCategory from "./components/Drawer/AddCategory";

const ConfirmDeleteProduct = styled(ConfirmDelete)`
  .modal-dialog {
    max-width: 377px;
  }
`;
require("dotenv").config();

const initialCategory = {
  _id: "",
  name: "",
  type: "",
};

function Category() {
  const {
    userEstablishment,
    userCategory,
    isPetEstablishment,
    isBeautyEstablishment,
    isRecreationEstablishment,
    isDrugStoreEstablishment,
    product,
    service,
  } = useAuth();
  const [qtLimitItem, setQtLimitItem] = useState(10);
  const [pageItemsList, setPageItemsList] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [deleteCategory, setDeleteCategory] = useState("");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [erroName, setErrorName] = useState(false);
  const [erroMessage, setErrorMessage] = useState("");

  const [isAddSubCategoryLoading, setIsAddSubCategoryLoading] = useState(false);
  // const [selectedCategoryChildren, setSelectedCategoryChildren] = useState("");
  const [types, setTypes] = useState([]);
  const [nameFilter, setNameFilter] = useState("");
  const [subCategories, setSubCategories] = useState([]);
  const [category, setCategory] = useState([]);
  const [isCategoriesLoading, setIsCategoriesLoading] = useState(false);
  // console.log("🚀 ~ file: index.js:37 ~ Category ~ category", category);
  // console.log("🚀 ~ file: index.js:35 ~ Category ~ subCategories", subCategories);
  const getSubCategory = async () => {
    // const conditionalTypeFilter = isBeautyEstablishment ? '&type=servico' : ''
    try {
      await api
        .get(
          `/sub-category-list/?establishment=${userEstablishment}&paginate=false&page=${pageItemsList}&limit=${qtLimitItem}&name=${nameFilter}`
        )
        .then((res) => {
          if (res?.data) {
            setSubCategories(res.data.data);
            setTotalItems(res.data.total);
          }
        });
    } catch (error) {
      console.log("Get Category", error);
    } finally {
      setIsCategoriesLoading(false);
    }
  };
  const getTypes = async () => {
    try {
      const data = await api.get(`/type`).then((res) => res.data);
      console.log("setting types data");
      setTypes(data);
    } catch (error) {
      console.log("Get Types", error);
    }
  };

  const handleCategoryChange = (event) => {
    setCategory((values) => ({
      ...values,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSubmitCategory = async (value) => {
    value.preventDefault();
    setIsAddSubCategoryLoading(true);

    if (category.name === "") {
      setErrorName(true);
      setErrorMessage("* Preencha todos os campos obrigatórios");
      setIsAddSubCategoryLoading(false);
      return false;
    }
    if (isPetEstablishment && category.type === "") {
      setErrorName(true);
      setErrorMessage("* Preencha todos os campos obrigatórios");
      setIsAddSubCategoryLoading(false);
      return false;
    }

    try {
      if (category._id) {
        editCategory();
      } else {
        let newCategory;
        if (isPetEstablishment) {
          newCategory = {
            name: category.name,
            type: category.type,
            slug: convertToSlug(category.name),
            establishment: userEstablishment,
            parent: userCategory,
          };
        } else if (isBeautyEstablishment) {
          newCategory = {
            name: category.name,
            type: service,
            slug: convertToSlug(category.name),
            establishment: userEstablishment,
            parent: userCategory,
          };
        } else if (isRecreationEstablishment) {
          newCategory = {
            name: category.name,
            type: product,
            slug: convertToSlug(category.name),
            establishment: userEstablishment,
            parent: userCategory,
          };
        } else if (isDrugStoreEstablishment) {
          newCategory = {
            name: category.name,
            type: product,
            slug: convertToSlug(category.name),
            establishment: userEstablishment,
            parent: userCategory,
          };
        } else {
          newCategory = {
            name: category.name,
            slug: convertToSlug(category.name),
            establishment: userEstablishment,
            parent: userCategory,
          };
        }
        console.log(newCategory);
        await api.post("/sub-category", newCategory);
      }
      getSubCategory();
    } catch (e) {
      console.log("Submit Category", e);
    } finally {
      setIsAddSubCategoryLoading(false);
      setOpenDrawer(false);
    }
  };

  const editCategory = async () => {
    try {
      let editCategory;
      if (isPetEstablishment) {
        editCategory = {
          name: category.name,
          type: category.type,
          slug: convertToSlug(category.name),
        };
      } else {
        editCategory = {
          name: category.name,
          slug: convertToSlug(category.name),
        };
      }
      await api.put(`/sub-category-update/${category._id}`, editCategory).then((resp) => {
        getSubCategory();
      });
    } catch (error) {
      console.log("Edit Category", error);
    }
  };

  const handleDeleteCategory = () => {
    try {
      api.put(`/sub-category-update/${deleteCategory}`, { status: "inactive" }).then((resp) => {
        swal("Sucesso!", "Produto deletado com sucesso!", "success");
        getSubCategory();
      });
    } catch (error) {
      console.log("Delete Category", error);
    }
  };

  const clearFields = () => {
    setCategory(initialCategory);
  };

  const handleSearch = useCallback(
    debounce((value) => search(value), 500),
    []
  );
  const search = (value) => {
    // console.log(value);
    setNameFilter(value);
    setPageItemsList(1);
  };
  const prevButton = () => {
    if (pageItemsList !== 1) {
      setPageItemsList(pageItemsList - 1);
    }
  };

  const nextButton = () => {
    let qtPages = Math.ceil(totalItems / qtLimitItem);
    if (pageItemsList.toString() !== qtPages.toString()) {
      setPageItemsList(parseInt(pageItemsList) + 1);
    }
  };

  const changePage = (event) => {
    setPageItemsList(event.target.id);
  };

  useEffect(() => {
    getSubCategory();
    getTypes();
  }, [nameFilter]);

  return (
    <>
      <Layout defaultMenu={6} title={"Categorias"} link={""}>
        <div className="store container-fluid px-lg-1 pt-1">
          <div className="row">
            <SearchInput onChange={handleSearch} />

            <div className={`ms-auto col-lg-auto  d-flex justify-content-end mb-3 mt-lg-2 `}>
              <button
                onClick={() => {
                  clearFields();
                  setOpenDrawer(true);
                }}
                className="w-100 btn bg-gradient-theme-blue text-white fz-14 px-3 py-2 d-flex justify-content-center align-items-center ff-univanova-medium"
              >
                Adicionar categoria
              </button>
            </div>
          </div>
          <div className="d-flex flex-column flex-lg-row pb-4">
            <List
              section="produtos"
              onChange={(e) => setQtLimitItem(e.target.value)}
              limit={qtLimitItem}
              totalItem={totalItems}
              page={pageItemsList}
              prevButton={() => prevButton()}
              nextButton={() => nextButton()}
              changePage={(e) => changePage(e)}
            >
              <CategoryList
                {...{
                  handleSearch,
                  setCategory,
                  setOpenDrawer,
                  subCategories,
                  isCategoriesLoading,
                  totalItems,
                  qtLimitItem,
                  setDeleteCategory,
                  setErrorMessage,
                  setErrorName,
                }}
              />
            </List>
          </div>
        </div>
      </Layout>
      <button
        id="btnCallConfirmDelete"
        className="d-none"
        data-bs-toggle="modal"
        data-bs-target="#ConfirmDeleteProduct"
      >
        Chamar modal confirm delete
      </button>
      <ConfirmDeleteProduct
        id="confirmDeleteProduct"
        onClick={handleDeleteCategory}
        title={"Tem certeza que quer excluir essa categoria?"}
        text={"Excluir categoria"}
      />
      <AddCategory
        {...{
          setOpenDrawer,
          openDrawer,
          category,
          handleCategoryChange,
          handleSubmitCategory,
          isAddSubCategoryLoading,
          erroMessage,
          erroName,
          isPetEstablishment,
          types,
        }}
      />
    </>
  );
}

export default Category;
